import React, { FC, Key } from "react";
import { noop } from "lodash";
import Parent from "../..";
import { InputifyComponentProps } from "../../../../utils/react";
import Item from "./components/Item";
import Root from "./components/Root";

const Vertical: FC<Vertical.Props> = ({
	style,
	className,

	value,

	options,

	onChange,
	onChangeSelectedOption,

	onEnter,
	onLeave,
	onFocus,
	onBlur,
}) => (
	<Root
		style={style}
		className={className}
		gaps="1px*"
		onMouseEnter={onEnter}
		onMouseLeave={onLeave}
		onFocus={onFocus}
		onBlur={onBlur}
	>
		{options.map((option) => (
			<Item
				key={option.key}
				disabled={option.disabled}
				selected={option.key === value}
				align="center"
				onClick={
					option.disabled
						? noop
						: () => {
								onChange(option.key);
								onChangeSelectedOption?.(option);
						  }
				}
			>
				{option.label}
			</Item>
		))}
	</Root>
);

declare namespace Vertical {
	export interface Props
		extends Omit<Parent.Props, "variant">,
			InputifyComponentProps<Key> {}
}

export default Vertical;
